module.exports = __webpack_public_path__ + "img/AGILOTUS.644dd486.svg";